module.exports = __webpack_public_path__ + "img/9788954613873.b4cc39ff.jpg";